import { testimonials } from '@/mocks/homeData';

export default function TestimonialSection() {
  return (
    <section id="testimonials" className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16">
          <div className="inline-block px-3 py-1 bg-accent-100 rounded-full mb-4">
            <span className="text-xs text-accent-900 font-medium whitespace-nowrap">学员心声</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight max-w-lg">
            他们都在bbgpt.online<br />实现了职业突破
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div
              key={t.name}
              className={`bg-background-50 rounded-2xl p-5 md:p-6 ${
                index % 3 === 1 ? 'md:translate-y-6' : index % 3 === 2 ? 'md:translate-y-3' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-secondary-100">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                    title={`${t.name} - bbgpt.online学员`}
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>

              <div className="mb-3 flex gap-0.5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </div>
                ))}
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{t.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}